import { computed, inject, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { FolderGlobalStore } from '../../../../store/medicalService/folder.global-store';

@Injectable()
export class FolderSuggestionsPageStore extends ComponentStoreV2Factory {
    protected readonly folderStore = inject(FolderGlobalStore);

    personId = computed(() => this.folderStore.folder()?.personId);
    serviceId = this.globalGlobalStore.loggedUserStore.selectedServiceId;
}
